import { Box, Button, Divider, Typography, useTheme } from "@mui/material";
import { Delete } from "@mui/icons-material";
import React from "react";
import { StakeholderRowContainer, StakeholderRowContent } from "./style";
import { Stakeholder } from "@components/StakeholdersCst";
import { useTranslation } from "react-i18next";

interface StakeholdersCstRowProps {
  stakeholder: Stakeholder;
  onDelete: () => void;
  disabled?: boolean;
  deleteTestId?: string;
  deleteAriaLabel?: string;
}

const StakeholdersCstRow = ({
  stakeholder,
  onDelete,
  disabled = false,
  deleteTestId,
  deleteAriaLabel,
}: StakeholdersCstRowProps) => {
  const theme = useTheme();
  const { t } = useTranslation(["stakeholders_section", "form"]);

  return (
    <Box>
      <StakeholderRowContainer theme={theme} gap={1}>
        <StakeholderRowContent gap={1}>
          {stakeholder.name && <Typography>{stakeholder.name}</Typography>}
          {stakeholder.type && (
            <Typography
              sx={{
                textTransform: "capitalize",
              }}
            >
              {stakeholder.type}
            </Typography>
          )}
          <Typography>
            {t("show_to_learner")}:{" "}
            <span
              style={{
                color: stakeholder.visStakeholder
                  ? theme.palette.success.main
                  : theme.palette.primary.main,
              }}
            >
              {stakeholder.visStakeholder ? t("yes") : t("no")}
            </span>
          </Typography>
        </StakeholderRowContent>
        <Button
          onClick={onDelete}
          startIcon={<Delete />}
          color={"primary"}
          variant={"contained"}
          disabled={disabled}
          {...(deleteTestId
            ? ({ id: deleteTestId, "data-testid": deleteTestId } as any)
            : {})}
          {...(deleteAriaLabel
            ? ({ "aria-label": deleteAriaLabel } as any)
            : {})}
          sx={{
            width: "auto",
            [theme.breakpoints.down("sm")]: {
              width: "100%",
            },
          }}
        >
          {t("delete")}
        </Button>
      </StakeholderRowContainer>
      <Divider />
    </Box>
  );
};

export default StakeholdersCstRow;
